import {
  Compare,
  Construction,
  Folder,
  AttachFile,
  LibraryBooks,
  Save,
} from '@mui/icons-material';

export type ResponseMode = 'fast' | 'thinking';

export const DEFAULT_RESPONSE_MODE: ResponseMode = 'thinking';

export const AI_TOOLS_MENU_ITEMS = [
  // Disabled until backend supports answer format options.
  // { key: 'answerFormat', translationKey: 'generic.answerFormat', Icon: TextFormat },
  { key: 'compare', translationKey: 'generic.compare', Icon: Compare },
  { key: 'savePrompt', translationKey: 'generic.savePrompt', Icon: Save },
  { key: 'options', translationKey: 'generic.options', Icon: Construction },
] as const;

export const QUICK_ACTION_ITEMS = [
  { key: 'bundles', translationKey: 'case.bundles', Icon: Folder },
  { key: 'documents', translationKey: 'case.documents', Icon: AttachFile },
  { key: 'prompt', translationKey: 'generic.prompt', Icon: LibraryBooks },
] as const;

export const CLOSE_DELAY_MS = 200;
